import * as palette from "@govlaunch/palette";
import { NextPage } from "next";
import Head from "next/head";
import Container from "../components/layout/Container";
import { Logo } from "../components/layout/icons";
import { getGovlaunchUrl } from "../components/utils/getGovlaunchUrl";

interface ErrorPageProps {
  statusCode: number | null;
  errorMessage?: string;
}

const Error: NextPage<ErrorPageProps> = ({ statusCode, errorMessage }) => {
  return (
    <>
      <Head>
        <title>{errorMessage || getErrorMessage(statusCode)}</title>
      </Head>

      <div
        css={{
          display: "flex",
          height: "100%",
          backgroundColor: palette.lightBlue
        }}
      >
        <Container>
          {statusCode === 404 ? (
            <div
              css={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
              }}
            >
              <h1
                css={{
                  marginTop: 80,
                  marginBottom: 0,
                  fontSize: 160,
                  color: palette.blue
                }}
              >
                404
              </h1>
              <h2
                css={{
                  fontSize: 32,
                  fontWeight: 300,
                  color: palette.blue,
                  textTransform: "uppercase",
                  margin: 0
                }}
              >
                PAGE NOT FOUND
              </h2>
            </div>
          ) : (
            <div
              css={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
              }}
            >
              <h1
                css={{
                  marginTop: 80,
                  marginBottom: 0,
                  fontSize: 70,
                  color: palette.blue,
                  textTransform: "uppercase"
                }}
              >
                Whoops!
              </h1>
              <h2
                css={{
                  fontSize: 26,
                  fontWeight: 300,
                  color: palette.blue,
                  textTransform: "uppercase",
                  marginBottom: 0
                }}
              >
                {errorMessage || "Something went wrong"}
              </h2>
            </div>
          )}

          <div
            css={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: 70
            }}
          >
            <Logo />

            <span
              css={{
                fontSize: 14,
                color: palette.text,
                marginTop: 5
              }}
            >
              Go back to the main site:
            </span>

            <a
              css={{
                marginTop: 5,
                color: palette.blue,

                textDecoration: "none",
                "&:focus, &:visited": {
                  color: palette.blue
                },

                "&:hover": {
                  color: palette.blue,
                  borderBottom: `solid 1px ${palette.blue}`
                }
              }}
              href={getGovlaunchUrl() || ""}
            >
              govlaunch.com
            </a>
          </div>
        </Container>
      </div>
    </>
  );
};

Error.getInitialProps = ({ res }) => {
  const statusCode = res ? res.statusCode : null;
  return { statusCode };
};

function getErrorMessage(statusCode: number | null) {
  if (statusCode === 404) {
    return "404 - Page not found";
  }

  return "Error - Something went wrong";
}

export default Error;
